<template>
    <div>
        <div class="section1" style="padding-top: 4rem;">
            <div class="price-title">
                <h1>先试用，再购买</h1>
                <p>多版本支撑不同规模企业，按需购买，助力产品快速增长</p>
            </div>
            <div class="price-wrap">
                <div class="combo clearfix">
                    <div class="combo-header">
                        <div class="combo-row">
                            <div class="combo-item combo-title">
                                <div>应用套餐</div>
                            </div>
                            <div class="combo-item combo-free" :class="active=='free'?'combo-ent' : ''">
                                <span>免费版</span>
                                <p>￥<i>0</i>/用3个月</p>
                                <div class="btn-try">免费使用</div>
                            </div>
                            <div class="combo-item combo-dev " :class="active=='dev'?'combo-ent' : ''">
                                <span>开发版</span>
                                <p>￥<i>30</i>/月</p>
                                <div class="btn-try">免费试用</div>
                            </div>
                            <div class="combo-item combo-spe" :class="active=='spe'?'combo-ent' : ''">
                                <span>专业版</span>
                                <p>￥<i>99</i>/月</p>
                                <div class="btn-try">免费试用</div>
                            </div>
                            <div class="combo-item combo-qiye" :class="active=='ent'?'combo-ent' : ''">
                                <span>企业版</span>
                                <p>￥<i>1199</i>/月</p>
                                <div class="btn-try">免费试用</div>
                            </div>
                            <div class="combo-item combo-pro" :class="active=='pro'?'combo-ent' : ''">
                                <span>企业版 Pro</span>
                                <p>￥<i>2299</i>起/月</p>
                                <div class="btn-try">免费试用</div>
                            </div>
                        </div>
                    </div>
                    <div class="combo-body clearfix">
                        <div class="combo-row clearfix active">
                            <div class="combo-item combo-title"><span>集群方案</span></div>
                            <div class="combo-item combo-free" :class="active=='free'?'combo-ent' : ''"><span>公有云</span></div>
                            <div class="combo-item combo-dev" :class="active=='dev'?'combo-ent' : ''"><span>公有云</span></div>
                            <div class="combo-item combo-spe" :class="active=='spe'?'combo-ent' : ''"><span>公有云</span></div>
                            <div class="combo-item" :class="active=='ent'?'combo-ent' : ''"><span>高可用</span></div>
                            <div class="combo-item combo-pro" :class="active=='pro'?'combo-ent' : ''"><span>独立</span></div>
                        </div>
                        <div class="combo-row clearfix">
                            <div class="combo-item combo-title"><span>数据 API</span></div>
                            <div class="combo-item combo-free" :class="active=='free'?'combo-ent' : ''"><span>100万次</span></div>
                            <div class="combo-item combo-dev" :class="active=='dev'?'combo-ent' : ''"><span>100万次</span></div>
                            <div class="combo-item combo-spe" :class="active=='spe'?'combo-ent' : ''"><span>500万次</span></div>
                            <div class="combo-item" :class="active=='ent'?'combo-ent' : ''"><span>3000万次</span></div>
                            <div class="combo-item combo-pro" :class="active=='pro'?'combo-ent' : ''"><span>不限</span></div>
                        </div>
                        <div class="combo-row clearfix">
                            <div class="combo-item combo-title"><span>表行数</span></div>
                            <div class="combo-item combo-free" :class="active=='free'?'combo-ent' : ''"><span>10万行</span></div>
                            <div class="combo-item combo-dev" :class="active=='dev'?'combo-ent' : ''"><span>10万行</span></div>
                            <div class="combo-item combo-spe" :class="active=='spe'?'combo-ent' : ''"><span>200万行</span></div>
                            <div class="combo-item" :class="active=='ent'?'combo-ent' : ''"><span>1000万行</span></div>
                            <div class="combo-item combo-pro" :class="active=='pro'?'combo-ent' : ''"><span>不限</span></div>
                        </div>
                        <div class="combo-row clearfix">
                            <div class="combo-item combo-title"><span>表列数</span></div>
                            <div class="combo-item combo-free" :class="active=='free'?'combo-ent' : ''"><span>20列</span></div>
                            <div class="combo-item combo-dev" :class="active=='dev'?'combo-ent' : ''"><span>20列</span></div>
                            <div class="combo-item combo-spe" :class="active=='spe'?'combo-ent' : ''"><span>50列</span></div>
                            <div class="combo-item" :class="active=='ent'?'combo-ent' : ''"><span>100列</span></div>
                            <div class="combo-item combo-pro" :class="active=='pro'?'combo-ent' : ''"><span>不限</span></div>
                        </div>
                        <div class="combo-row clearfix">
                            <div class="combo-item combo-title"><span>建表数</span></div>
                            <div class="combo-item combo-free" :class="active=='free'?'combo-ent' : ''"><span>20个</span></div>
                            <div class="combo-item combo-dev" :class="active=='dev'?'combo-ent' : ''"><span>20个</span></div>
                            <div class="combo-item combo-spe" :class="active=='spe'?'combo-ent' : ''"><span>50个</span></div>
                            <div class="combo-item" :class="active=='ent'?'combo-ent' : ''"><span>200个</span></div>
                            <div class="combo-item combo-pro" :class="active=='pro'?'combo-ent' : ''"><span>不限</span></div>
                        </div>
                        <div class="combo-row clearfix">
                            <div class="combo-item combo-title"><span>并发数(半小时)</span></div>
                            <div class="combo-item combo-free" :class="active=='free'?'combo-ent' : ''"><span>2000</span></div>
                            <div class="combo-item combo-dev" :class="active=='dev'?'combo-ent' : ''"><span>2000</span></div>
                            <div class="combo-item combo-spe" :class="active=='spe'?'combo-ent' : ''"><span>10000</span></div>
                            <div class="combo-item" :class="active=='ent'?'combo-ent' : ''"><span>不限</span></div>
                            <div class="combo-item combo-pro" :class="active=='pro'?'combo-ent' : ''"><span>不限</span></div>
                        </div>
                        <div class="combo-row clearfix">
                            <div class="combo-item combo-title"><span>带宽大小(/次)</span></div>
                            <div class="combo-item combo-free" :class="active=='free'?'combo-ent' : ''"><span>204800 bytes</span></div>
                            <div class="combo-item combo-dev" :class="active=='dev'?'combo-ent' : ''"><span>204800 bytes</span></div>
                            <div class="combo-item combo-spe" :class="active=='spe'?'combo-ent' : ''"><span>409600 bytes</span></div>
                            <div class="combo-item" :class="active=='ent'?'combo-ent' : ''"><span>1024000 bytes</span></div>
                            <div class="combo-item combo-pro" :class="active=='pro'?'combo-ent' : ''"><span>不限</span></div>
                        </div>
                        <div class="combo-row clearfix">
                            <div class="combo-item combo-title"><span>模糊查询</span></div>
                            <div class="combo-item combo-free" :class="active=='free'?'combo-ent' : ''"><span><img :src="active=='free'?x1:x" /></span></div>
                            <div class="combo-item combo-dev" :class="active=='dev'?'combo-ent' : ''"><span><img :src="active=='dev'?x1:x" /></span></div>
                            <div class="combo-item combo-spe" :class="active=='spe'?'combo-ent' : ''"><span><img :src="active=='spe'?ok1:ok" /></span></div>
                            <div class="combo-item" :class="active=='ent'?'combo-ent' : ''"><span><img :src="active=='ent'?ok1:ok" /></span></div>
                            <div class="combo-item combo-pro" :class="active=='pro'?'combo-ent' : ''"><span><img :src="active=='pro'?ok1:ok" /></span></div>
                        </div>
                        <div class="combo-row clearfix">
                            <div class="combo-item combo-title"><span>小程序支付</span></div>
                            <div class="combo-item combo-free" :class="active=='free'?'combo-ent' : ''"><span><img :src="active=='free'?x1:x" /></span></div>
                            <div class="combo-item combo-dev" :class="active=='dev'?'combo-ent' : ''"><span><img :src="active=='dev'?x1:x" /></span></div>
                            <div class="combo-item combo-spe" :class="active=='spe'?'combo-ent' : ''"><span><img :src="active=='spe'?ok1:ok" /></span></div>
                            <div class="combo-item" :class="active=='ent'?'combo-ent' : ''"><span><img :src="active=='ent'?ok1:ok" /></span></div>
                            <div class="combo-item combo-pro" :class="active=='pro'?'combo-ent' : ''"><span><img :src="active=='pro'?ok1:ok" /></span></div>
                        </div>
                        <div class="combo-row clearfix">
                            <div class="combo-item combo-title"><span>文件域名</span></div>
                            <div class="combo-item combo-free" :class="active=='free'?'combo-ent' : ''"><span>按需开启</span></div>
                            <div class="combo-item combo-dev" :class="active=='dev'?'combo-ent' : ''"><span>按需开启</span></div>
                            <div class="combo-item combo-spe" :class="active=='spe'?'combo-ent' : ''"><span>按需开启</span></div>
                            <div class="combo-item" :class="active=='ent'?'combo-ent' : ''"><span>免费开启</span></div>
                            <div class="combo-item combo-pro" :class="active=='pro'?'combo-ent' : ''"><span>免费开启</span></div>
                        </div>
                        <div class="combo-row clearfix">
                            <div class="combo-item combo-title"><span>文件 FTP</span></div>
                            <div class="combo-item combo-free" :class="active=='free'?'combo-ent' : ''"><span>按需开启</span></div>
                            <div class="combo-item combo-dev" :class="active=='dev'?'combo-ent' : ''"><span>按需开启</span></div>
                            <div class="combo-item combo-spe" :class="active=='spe'?'combo-ent' : ''"><span>按需开启</span></div>
                            <div class="combo-item" :class="active=='ent'?'combo-ent' : ''"><span>按需开启</span></div>
                            <div class="combo-item combo-pro" :class="active=='pro'?'combo-ent' : ''"><span>按需开启</span></div>
                        </div>
                        <div class="combo-row clearfix">
                            <div class="combo-item combo-title"><span>云函数</span></div>
                            <div class="combo-item combo-free" :class="active=='free'?'combo-ent' : ''"><span>免费使用40天</span></div>
                            <div class="combo-item combo-dev" :class="active=='dev'?'combo-ent' : ''"><span>免费使用40天</span></div>
                            <div class="combo-item combo-spe" :class="active=='spe'?'combo-ent' : ''"><span>免费使用40天</span></div>
                            <div class="combo-item" :class="active=='ent'?'combo-ent' : ''"><span>免费开启</span></div>
                            <div class="combo-item combo-pro" :class="active=='pro'?'combo-ent' : ''"><span>免费开启</span></div>
                        </div>
                        <div class="combo-row clearfix">
                            <div class="combo-item combo-title"><span>数据监听</span></div>
                            <div class="combo-item combo-free" :class="active=='free'?'combo-ent' : ''"><span>按需开启</span></div>
                            <div class="combo-item combo-dev" :class="active=='dev'?'combo-ent' : ''"><span>按需开启</span></div>
                            <div class="combo-item combo-spe" :class="active=='spe'?'combo-ent' : ''"><span>按需开启</span></div>
                            <div class="combo-item" :class="active=='ent'?'combo-ent' : ''"><span>按需开启</span></div>
                            <div class="combo-item combo-pro" :class="active=='pro'?'combo-ent' : ''"><span>按需开启</span></div>
                        </div>
                        <div class="combo-row clearfix">
                            <div class="combo-item combo-title"><span>海外加速</span></div>
                            <div class="combo-item combo-free" :class="active=='free'?'combo-ent' : ''"><span>按需开启</span></div>
                            <div class="combo-item combo-dev" :class="active=='dev'?'combo-ent' : ''"><span>按需开启</span></div>
                            <div class="combo-item combo-spe" :class="active=='spe'?'combo-ent' : ''"><span>按需开启</span></div>
                            <div class="combo-item" :class="active=='ent'?'combo-ent' : ''"><span>按需开启</span></div>
                            <div class="combo-item combo-pro" :class="active=='pro'?'combo-ent' : ''"><span>免费开启</span></div>
                        </div>
                        <div class="combo-row clearfix">
                            <div class="combo-item combo-title"><span>文件存储</span></div>
                            <div class="combo-item combo-free" :class="active=='free'?'combo-ent' : ''"><span>每账户免费20GB</span></div>
                            <div class="combo-item combo-dev" :class="active=='dev'?'combo-ent' : ''"><span>每账户免费20GB</span></div>
                            <div class="combo-item combo-spe" :class="active=='spe'?'combo-ent' : ''"><span>每账户免费20GB</span></div>
                            <div class="combo-item" :class="active=='ent'?'combo-ent' : ''"><span>每账户免费20GB</span></div>
                            <div class="combo-item combo-pro" :class="active=='pro'?'combo-ent' : ''"><span>每账户免费20GB</span></div>
                        </div>
                        <div class="combo-row clearfix">
                            <div class="combo-item combo-title"><span>文件流量</span></div>
                            <div class="combo-item combo-free" :class="active=='free'?'combo-ent' : ''"><span>每账户每月免费20GB</span></div>
                            <div class="combo-item combo-dev" :class="active=='dev'?'combo-ent' : ''"><span>每账户每月免费20GB</span></div>
                            <div class="combo-item combo-spe" :class="active=='spe'?'combo-ent' : ''"><span>每账户每月免费20GB</span></div>
                            <div class="combo-item" :class="active=='ent'?'combo-ent' : ''"><span>每账户每月免费20GB</span></div>
                            <div class="combo-item combo-pro" :class="active=='pro'?'combo-ent' : ''"><span>每账户每月免费20GB</span></div>
                        </div>
                        <div class="combo-row clearfix">
                            <div class="combo-item combo-title"><span>团队管理</span></div>
                            <div class="combo-item combo-free" :class="active=='free'?'combo-ent' : ''"><span><img :src="active=='free'?x1:x" /></span></div>
                            <div class="combo-item combo-dev" :class="active=='dev'?'combo-ent' : ''"><span><img :src="active=='dev'?x1:x" /></span></div>
                            <div class="combo-item combo-spe" :class="active=='spe'?'combo-ent' : ''"><span><img :src="active=='spe'?ok1:ok" /></span></div>
                            <div class="combo-item" :class="active=='ent'?'combo-ent' : ''"><span><img :src="active=='ent'?ok1:ok" /></span></div>
                            <div class="combo-item combo-pro" :class="active=='pro'?'combo-ent' : ''"><span><img :src="active=='pro'?ok1:ok" /></span></div>
                        </div>
                        <div class="combo-row clearfix">
                            <div class="combo-item combo-title"><span>软件著作权</span></div>
                            <div class="combo-item combo-free" :class="active=='free'?'combo-ent' : ''"><span><img :src="active=='free'?ok1:ok" /></span></div>
                            <div class="combo-item combo-dev" :class="active=='dev'?'combo-ent' : ''"><span><img :src="active=='dev'?ok1:ok" /></span></div>
                            <div class="combo-item combo-spe" :class="active=='spe'?'combo-ent' : ''"><span><img :src="active=='spe'?ok1:ok" /></span></div>
                            <div class="combo-item" :class="active=='ent'?'combo-ent' : ''"><span><img :src="active=='ent'?ok1:ok" /></span></div>
                            <div class="combo-item combo-pro" :class="active=='pro'?'combo-ent' : ''"><span><img :src="active=='pro'?ok1:ok" /></span></div>
                        </div>
                        <div class="combo-row clearfix">
                            <div class="combo-item combo-title"><span>服务支持</span></div>
                            <div class="combo-item combo-free" :class="active=='free'?'combo-ent' : ''"><span>工单（正常回复）</span></div>
                            <div class="combo-item combo-dev" :class="active=='dev'?'combo-ent' : ''"><span>工单（正常回复）</span></div>
                            <div class="combo-item combo-spe" :class="active=='spe'?'combo-ent' : ''"><span>工单（优先回复）</span></div>
                            <div class="combo-item" :class="active=='ent'?'combo-ent' : ''"><span>工单（及时回复）</span></div>
                            <div class="combo-item combo-pro" :class="active=='pro'?'combo-ent' : ''"><span>独立服务群（及时回复）</span></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="msg-wrap">
                <div class="price-wrap">
                    <div class="price-title" style="padding: 4rem 0 2.3rem;">
                        <h1>服务按需购买</h1>
                    </div>
                    <div class="price-server clearfix">
                        <div class="server-item">
                            <div class="server-wrap">
                                <img src="@/assets/images/price/1.png">
                                <strong>数据 API</strong>
                                <div class="server-body">
                                    超出套餐 API 数额后可购买<br><span>0.5元/万次</span>
                                </div>
                            </div>
                        </div>
                        <div class="server-item">
                            <div class="server-wrap">
                                <img src="@/assets/images/price/2.png">
                                <strong>云函数</strong>
                                <div class="server-body">
                                    免费使用40天<br><span>50元/月</span>
                                </div>
                            </div>
                        </div>
                        <div class="server-item">
                            <div class="server-wrap">
                                <img src="@/assets/images/price/3.png">
                                <strong>短信</strong>
                                <div class="server-body">
                                    每账户免费30条<br><span>0.06/元</span>起每条
                                </div>
                            </div>
                        </div>
                        <div class="server-item">
                            <div class="server-wrap">
                                <img src="@/assets/images/price/4.png">
                                <strong>节点海外加速</strong>
                                <div class="server-body">
                                    支持全球节点加速服务<br><span>300元/月</span>
                                </div>
                            </div>
                        </div>
                        <div class="server-item">
                            <div class="server-wrap">
                                <img src="@/assets/images/price/5.png">
                                <strong>文件域名</strong>
                                <div class="server-body">
                                    文件服务域名使用/独立绑定<br><span>100元/年</span>
                                </div>
                            </div>
                        </div>
                        <div class="server-item">
                            <div class="server-wrap">
                                <img src="@/assets/images/price/6.png">
                                <strong>文件储存</strong>
                                <div class="server-body">
                                    每账户免费20GB<br>超出后每月<span>0.3元/GB</span>
                                </div>
                            </div>
                        </div>
                        <div class="server-item">
                            <div class="server-wrap">
                                <img src="@/assets/images/price/7.png">
                                <strong>文件流量</strong>
                                <div class="server-body">
                                    每账户每月免费20GB<br>超出后<span>0.5元/GB</span>
                                </div>
                            </div>
                        </div>
                        <div class="server-item">
                            <div class="server-wrap">
                                <img src="@/assets/images/price/8.png">
                                <strong>企业版 Pro</strong>
                                <div class="server-body">
                                    Pro版有多个版本支持 (A/B/C)<br>如需请联系 <span>{{$store.getters.email}} </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="question-wrap">
                <div class="price-wrap">
                    <div class="price-title" style="padding: 2rem 0 1rem;">
                        <h1>常见问题</h1>
                    </div>
                    <dl>
                        <span class="circle-q">Q1</span>
                        <div class="content">
                            <dt>四个不同的计价套餐，哪个适合我？</dt>
                            <dd>针对不同规模的企业和团队，我们推出了开发版、专业版、企业版和企业版 Pro 四个版本。<br>
                                免费版适合产品开发阶段或者个人项目使用，在此基础之上，专业版增加了更性价比的服务功能，适用于创业初期项目或种子期项目，这两个版本的用户都是运行在公有集群中。<br>
                                企业版使用了高性能、高可用的应用解决方案，适用于初期的商业项目。<br>
                                企业版 Pro 使用了独立部署集群的应用解决方案，可灵活应对多样化的企业需求。Pro 版本有A、B、C三种，灵活定制，满足企业各种业务需求，适用于成熟的商业项目。
                            </dd>
                        </div>
                    </dl>
                    <dl>
                        <span class="circle-q">Q2</span>
                        <div class="content">
                            <dt>不同套餐之间可以随意切换么？</dt>
                            <dd>可以切换，每个版本都可以随时升级到更高的版本，如果升级的时候本套餐还有剩余期系统会换算结余金额，补完差价后即刻升级。<br>
                                如套餐需切换更低的版本，则需等到本套餐使用完成后方可切换，因为降低套餐平台存在数据迁移过程和硬件成本。
                            </dd>
                        </div>
                    </dl>
                    <dl>
                        <span class="circle-q">Q3</span>
                        <div class="content">
                            <dt>可以通过哪些方式支付费用，有发票提供么？</dt>
                            <dd>目前我们支持多种支付方式：<br>
                                1) 线下支付，您可以在付费页面查看到比目公司的对公账户信息，然后通过银行转账支付，并发送回执确认，确认到账官方人员会给您账户打入余额，通过账户余额可购买相关服务。<br>
                                2) 在线支付，如果使用在线购买，打开管理控制台，应用→设置→套餐升级
                                进行付费，直接通过微信支付或者支付宝进行在线支付，在线支付后对应套餐功能会实时开通。<br>
                                我们提供正规的增值税普通发票，你可以直接在线索取发票，打开管理控制台，财务→发票管理 进行申请。申请时你只要填写相关信息并提交审核，审核通过后，我们会给你寄送过去，发票额少于1000的不包运费。
                            </dd>
                        </div>
                    </dl>
                    <dl>
                        <span class="circle-q">Q4</span>
                        <div class="content">
                            <dt>套餐中的某些额度到了限制值，是否可以按需购买？</dt>
                            <dd>可以根据产品需要进行按需购买。平台数据 API 数、文件存储量、文件流量和短信都可以按需购买。另外文件域名、文件FTP上传、访问节点海外加速和云函数等功能都可以按需单独开通。</dd>
                        </div>
                    </dl>
                    <dl>
                        <span class="circle-q">Q5</span>
                        <div class="content">
                            <dt>是否支持海外用户访问？</dt>
                            <dd>如需更好的支持海外用户访问，我们提供了全球节点加速服务，加速服务使用了国内知名第三方CDN厂商服务，据开发者反馈，使用了全球加速服务，效果还是很不错的。</dd>
                        </div>
                    </dl>
                    <dl>
                        <span class="circle-q">Q6</span>
                        <div class="content">
                            <dt>文件访问域名可以使用独立的域名么，上传大文件呢？</dt>
                            <dd>平台支持文件访问域名进行变更，必须提供已备案的域名地址才可上传文件。平台网页提供的文件上传最大值为50 MB，如需要上传大文件，可开通文件FTP。
                            </dd>
                        </div>
                    </dl>
                </div>
            </div>
            <!-- <?php if (Yii::app()->request->cookies[Yii::app()->params['ad_360_cookie']]): ?>
      <div align="center">
        <?php if ($is_mobile): ?>
        <script
          type="text/javascript"
          src="<?= Yii::app()->params['themeStaticHost'] ?>/js/ad/360_400_300.js?<?= Yii::app()->params['jsVersion'] ?>"
        />
        <?php endif; ?>
      </div>
      <?php endif; ?> -->
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            active: 'free', //  free dev spe ent pro
            ok: require("@/assets/images/price/ok.png"),
            ok1: require("@/assets/images/price/ok1.png"),
            x: require("@/assets/images/price/x.png"),
            x1: require("@/assets/images/price/x1.png"),
        }
    },
    mounted() {
        const that = this;
        $(".combo-item").hover(function() {
            let c = $(this)[0].getAttribute('class')
            if (c.indexOf('combo-free') > -1) {
                that.active = 'free'
            } else if (c.indexOf('combo-dev') > -1) {
                that.active = 'dev'
            } else if (c.indexOf('combo-spe') > -1) {
                that.active = 'spe'
            } else if (c.indexOf('combo-pro') > -1) {
                that.active = 'pro'
            } else {
                that.active = 'ent'
            }
            console.log(c)
        }, function() {
            // console.log($(this))
        });

        $(function() {
            // 实现价格漂移
            if ($(window).width() >= 320 && $(window).width() <= 768) {
                navScroll(200, 2100)
            } else {
                navScroll(487, 1450)
            }
            //   $('[data-toggle=tooltip]').tooltip()
        })

        function navScroll(star, from) {
            $(window).on('scroll', function() {
                var top = $(this).scrollTop();
                console.log('top', top)
                if (top > from) {
                    $('.combo-header .combo-row').removeClass('scroll').addClass('fixedScroll')
                } else if (top > star) {
                    $('.combo-header .combo-row').addClass('scroll')
                } else {
                    $('.combo-header .combo-row').removeClass('scroll').removeClass('fixedScroll')
                }
            })
        }
    }
}
</script>
<style scoped>
@import '~@/styles/prices.css'
</style>